var map = {
	"./account.svg": "./src/icons/svg/account.svg",
	"./arrow-down-solid.svg": "./src/icons/svg/arrow-down-solid.svg",
	"./arrow-icon.svg": "./src/icons/svg/arrow-icon.svg",
	"./arrow-left.svg": "./src/icons/svg/arrow-left.svg",
	"./arrow-right.svg": "./src/icons/svg/arrow-right.svg",
	"./arrow-up-solid.svg": "./src/icons/svg/arrow-up-solid.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./cart-icon.svg": "./src/icons/svg/cart-icon.svg",
	"./centos-brands.svg": "./src/icons/svg/centos-brands.svg",
	"./check.svg": "./src/icons/svg/check.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./closed-lock.svg": "./src/icons/svg/closed-lock.svg",
	"./cog.svg": "./src/icons/svg/cog.svg",
	"./companion.svg": "./src/icons/svg/companion.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./copy.svg": "./src/icons/svg/copy.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./e-learning-espace.svg": "./src/icons/svg/e-learning-espace.svg",
	"./e-learning-white.svg": "./src/icons/svg/e-learning-white.svg",
	"./e-learning.svg": "./src/icons/svg/e-learning.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./elearning.svg": "./src/icons/svg/elearning.svg",
	"./eye-close.svg": "./src/icons/svg/eye-close.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./face-to-face-icon.svg": "./src/icons/svg/face-to-face-icon.svg",
	"./facebook.svg": "./src/icons/svg/facebook.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./hand.svg": "./src/icons/svg/hand.svg",
	"./home-solid.svg": "./src/icons/svg/home-solid.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./info-solid.svg": "./src/icons/svg/info-solid.svg",
	"./instagram.svg": "./src/icons/svg/instagram.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./logout.svg": "./src/icons/svg/logout.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./open-book-icon.svg": "./src/icons/svg/open-book-icon.svg",
	"./open-lock.svg": "./src/icons/svg/open-lock.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./phone-icon.svg": "./src/icons/svg/phone-icon.svg",
	"./plus-circle.svg": "./src/icons/svg/plus-circle.svg",
	"./practice-icon.svg": "./src/icons/svg/practice-icon.svg",
	"./pratique.svg": "./src/icons/svg/pratique.svg",
	"./print.svg": "./src/icons/svg/print.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./quote-left.svg": "./src/icons/svg/quote-left.svg",
	"./quote-right.svg": "./src/icons/svg/quote-right.svg",
	"./ranking-icon.svg": "./src/icons/svg/ranking-icon.svg",
	"./remove-circle.svg": "./src/icons/svg/remove-circle.svg",
	"./search-icon.svg": "./src/icons/svg/search-icon.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./times-circle.svg": "./src/icons/svg/times-circle.svg",
	"./times.svg": "./src/icons/svg/times.svg",
	"./trash.svg": "./src/icons/svg/trash.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./visio-icon.svg": "./src/icons/svg/visio-icon.svg",
	"./visio.svg": "./src/icons/svg/visio.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";